import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../lib/auth";
import NavBar from "../components/NavBar";

export default function Signup() {
  const { signup } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [form, setForm] = useState({ email: "", password: "", name: "", company: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      await signup(form);
      const buy = params.get("service") || params.get("buy");
      nav(buy ? `/dashboard?buy=${buy}` : "/dashboard");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Signup failed");
    } finally { setLoading(false); }
  };

  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  return (
    <div data-testid="signup-page">
      <NavBar />
      <div className="max-w-md mx-auto px-6 py-20">
        <div className="label-eyebrow mb-3">AUTH / 02</div>
        <h1 className="font-display text-4xl font-black uppercase tracking-tight mb-8">Create account</h1>
        <form onSubmit={submit} className="space-y-4 tech-card p-6" data-testid="signup-form">
          <div>
            <label className="ribbon block mb-2">Name</label>
            <input className="input" value={form.name} onChange={upd("name")} data-testid="signup-name" />
          </div>
          <div>
            <label className="ribbon block mb-2">Company</label>
            <input className="input" value={form.company} onChange={upd("company")} data-testid="signup-company" />
          </div>
          <div>
            <label className="ribbon block mb-2">Email</label>
            <input className="input" type="email" required value={form.email}
                   onChange={upd("email")} data-testid="signup-email" />
          </div>
          <div>
            <label className="ribbon block mb-2">Password (min 6 chars)</label>
            <input className="input" type="password" required minLength={6} value={form.password}
                   onChange={upd("password")} data-testid="signup-password" />
          </div>
          {err && <div className="text-sm text-red-700 border border-red-700 p-2" data-testid="signup-error">{err}</div>}
          <button className="btn btn-primary w-full justify-center" disabled={loading} data-testid="signup-submit">
            {loading ? "..." : "Create account →"}
          </button>
        </form>
        <p className="mt-4 text-sm text-black/70">
          Already have an account? <Link to="/login" className="underline" data-testid="signup-to-login">Sign in</Link>.
        </p>
      </div>
    </div>
  );
}
